import { APIS, TENANT_ID } from "../../../utils/api-factory"
import { POST_HEADER ,TENANT_HEADER,TENANT_POST_HEADER} from "../../../utils/apiHeaders"

export const saveAgreegatorDataApi = (agreegatorData, callBack) => {
  fetch(APIS.SAVE_AGREEGATOR_DATA, {
    method: 'POST',
    headers: TENANT_POST_HEADER,
    body: JSON.stringify(agreegatorData)
  })
    .then(res => res.text())
    .then(json => {
      callBack(json)
    })
}

export const getUrlApi = (file, name, fileType, callBack) => {
  return new Promise((resolve, reject) => {
    let imageFormData = new FormData()
    imageFormData.append('uploadfile', file)
    imageFormData.append('type', fileType)
    imageFormData.append('fileName', name)
    var xhr = new XMLHttpRequest()

    xhr.open('post', APIS.GENERIC_FILE_UPLOAD_AND_GET_URL, true)
    xhr.onload = function () {
      if (this.status == 200) {
        resolve(this.response)
        callBack(this.response)
      } else {
        reject(this.statusText)
      }
    }
    xhr.send(imageFormData)
  })
}


export const getMarketListing = (pageNumber, noOfEntry, callBack) => {

  fetch(
    APIS.GET_MARKETING_LIST + pageNumber + '&count=' + noOfEntry)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })

}
export const getAgreegatorListApi = (callBack) => {

  fetch(
    APIS.GET_AGREEGATOR_LIST,{headers:{'X-Tenant-ID':TENANT_ID}})
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })

}
export const saveBugetPlan = (budegtPlanData, callBack) => {
  fetch(APIS.SAVE_BUDGET_PLAN, {
    method: 'POST',
    headers: TENANT_POST_HEADER,
    body: JSON.stringify(budegtPlanData)
  })
    .then(res => res.text())
    .then(json => {
      callBack(json)
    })
}
export const getEventDataByPartnerId = (partnerId, callBack) => {

  fetch(
    APIS.GET_EVENT_DATA_BY_PARTNER_ID + partnerId,{
      headers:{
        'X-Tenant-ID': TENANT_ID
      }
    })
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })

}
export const projectionData = (months,startDate, endDate, callBack) => {

  fetch(APIS.PROJECTION_DATA_MONTHS + months + '&startDate=' + startDate + '&endDate=' + endDate,{headers:{
    'X-Tenant-ID': TENANT_ID
  }})
    .then(res => res.json())
    .then(json => {
      console.log(json)
      callBack(json)
    })

}
export const getListUnmappedCampaigns = ( callBack) => {

  fetch(APIS.GET_LIST_UNMAPPED_CAMPAIGNS ,{headers:{
    'X-Tenant-ID': TENANT_ID
  }})
    .then(res => res.json())
    .then(json => {
      console.log(json)
      callBack(json)
    })

}
export const getAllAggregatorsNamesList = ( callBack) => {

  fetch(APIS.GET_ALL_AGGREGATORS_NAMES ,{headers:{
    'X-Tenant-ID': TENANT_ID
  }})
    .then(res => res.json())
    .then(json => {
      console.log(json)
      callBack(json)
    })

}
export const getAllPartnerNamesListbyAggregatorNames = (name, callBack) => {

  fetch(APIS.GET_ALL_PARTNER_NAMES_BY_AGGREGATOR_NAMES + name ,{headers:{
    'X-Tenant-ID': TENANT_ID
  }})
    .then(res => res.json())
    .then(json => {
      console.log(json)
      callBack(json)
    })

}
export const projectionDataDaywise = (months, startDate, endDate, callBack) => {

  fetch(
    APIS.PROJECTION_DAY_WISE + months + '&startDate=' + startDate + '&endDate=' + endDate,{headers:{
      'X-Tenant-ID': TENANT_ID
    }})
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })

}
export const SavecampgaingsMappingData = (data, callBack) => {

  fetch(
    APIS.SAVE_CAMPAGINS_MAPPINGS_DATA ,{
      method:"POST",
      body:JSON.stringify(data),
      headers:TENANT_POST_HEADER
    })
    .then(res => res.text())
    .then(json => {
      callBack(json)
    })

}
export const getMappedcampagions = ( callBack) => {

  fetch(
    APIS.MAPPED_CAMPAIGNS_GET ,TENANT_HEADER)
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })

}


export const downloadMappedcamapgins = (callBack) => {
  
  fetch(APIS.DOWNLOAD_MAPPED_CAMPAIGNS_LIST, TENANT_HEADER)
    .then(res => res.blob())
    .then(data => {
      var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      var excelBlob = new Blob(
        [data],
        { type: 'application/vnd.ms-excel' },
        'excel.xls'
      )
      var downloadUrl = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = downloadUrl
      a.download = 'Mappedcampaings.xls'
      document.body.appendChild(a)
      a.click()
      callBack(data)
    })
}

export const SavePartnerNameBycsv = (imageFormData, callBack) => {
  var self = this
  return new Promise((resolve, reject) => {
    var self = this
   
    var xhr = new XMLHttpRequest()
    xhr.open('post', APIS.SAVE_PARTNER_NAME_BY_CSV_DATA, true)
     xhr.setRequestHeader("X-Tenant-ID", TENANT_ID); 
    xhr.onload = function () {
      if (this.status == 200) {
        resolve(this.response)
        callBack(this.response)
      } else {
        reject(this.statusText)
      }
    }
    xhr.send(imageFormData)
  })
}